export default __webpack_public_path__ + "static/weel-homepage-animation-773f2cfacce7ade44a5018484723fd3b.webm";